<template>
  <vue-modal :key="refreshModal" :ref="modalId" :name="modalId" :clickToClose="false" :draggable="true" @opened="loadData" :adaptive="true" :resizable="true" :scrollable="true" width="820" :maxHeight="1050" :height="'auto'">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div v-show="getDisplayView()" class="modal-body manage-unique-codes">
        <div class="m-1 info-message" v-if="!error">{{ returnMessage }}</div>
        <div class="error-message" v-if="error">{{ returnMessage }}</div>        
            <div class="form-group form-inline pt-1 pb-1 no-gutters">
                <label for="inputFile">Input Type</label>
                <div class="ml-2 form-check form-check-inline">
                  <input type="radio" id="inputList" name="inputList" class="form-check-input" value="list"  v-model="inputType">By List 
                </div>
                <div class="form-check form-check-inline">
                  <input type="radio" id="inputFile" name="inputFile" class="form-check-input" value="file" v-model="inputType">By File 
                </div>
            </div>                
            <div class="form-row">
            <div v-show="isList" class="form-group form-inline w-100">
                <label for="uniqueCodeIds" class="mr-1">Unique Code Ids</label>
                <input type="text" class="form-control w-50" placeholder="Enter comma delimited list of Unique Code Ids" id="uniqueCodeIds" name="uniqueCodeIds" v-model="uniqueCodeIds" />
            </div>
            <div v-show="isFile" class="form-group form-row">
              <span class="pr-2">Select a file</span>
              <input ref="deleteUniqueCodeDataFile" type="file" @change="onFileChange" />
            </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <div>
            <button v-show="isFile" type="submit" class="btn btn-primary ml-2" v-on:click="this.deleteFromFile">
              <span>Delete</span>
              <span v-show="getModalLoading()" class="spinner-border spinner-border-sm"></span>
            </button>
            <button v-show="isList" type="button" class="btn btn-primary ml-4" @click="deleteFromList" :disabled="disableButton">{{ buttonName }}</button>
            <button type="button" class="btn btn-primary ml-4" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import SurveyService from "../services/survey.service";
import AlertService from "../services/alert.service";
import AdminService from "../services/admin.service";
import ViewMixins from "../mixins/ViewMixins.vue";

export default {
  name: "ManageUniqueCodes",
  mixins: [ViewMixins],
  components: {},
  data() {
    return {
      uniqueCodeList: [],
      uniqueCodeIds: "",
      returnMessage: "",
      disableButton: false,
      error: false,
      deleteUniqueCodeFile: "",
      inputType: "list",
      refreshModal: true
    };
  },
  props: {
    inputMode: {
        type: String,
        default: ""
    },     
    modalId: {
      type: String,
      default: "manage-unique-codes",
    },
    modalTitle: {
      type: String,
      default: "Manage Unique Codes",
    },
  },
  computed: {
    isList: function(){
        return this.inputType == "list";
    },
    isFile: function(){
        return this.inputType == "file";
    },    
    buttonName: function(){
        if (this.inputMode == "delete" ){
            return "Delete";
        }
        return "";
    },
    requestMessage: function(){
        if (this.inputMode == "delete" ){
            return "Deleting Unique Codes";
        }
        return "";
    },
  },
  mounted() {},
  created() {},
  methods: {
    onFileChange: function() {
      this.deleteUniqueCodeFile = this.$refs.deleteUniqueCodeDataFile.files[0];
    },
    async deleteFromFile() {
      if (this.deleteUniqueCodeFile){  
        this.$root.processServerRequest("Deleting Unique Codes");
        this.setModalLoading(true);
        if (this.inputMode == "delete" ){
          SurveyService.deleteUniqueCodesByFile(this.deleteUniqueCodeFile, this.processDeleteUniqueCodesCallback, this);
        }
      } else {
        AdminService.displayErrorMessage({ text: "Please choose a file to upload." });
      }      
    },
    deleteFromList(){
        this.uniqueCodesList = this.uniqueCodeIds.split(",");
        this.$root.processServerRequest(this.requestMessage);
        this.disableButton = true;
        if (this.inputMode == "delete" ){
            SurveyService.deleteUniqueCodesByList(this.uniqueCodesList, this.processDeleteUniqueCodesCallback, this);
        }
    },
    processDeleteUniqueCodesCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      this.returnMessage = response.data.message;
      this.setDisplayView(true);
      this.setModalLoading(false);      
      this.disableButton = false;
      if (statusCode == 200) {
        this.error = false;
      } else {
        this.error = true;
        AdminService.displayErrorMessage({ text: response.data.message });
      }
      this.disableButton = false;
    },
    loadData() {
      this.reset();
    },
    reset() {
      AlertService.closeAlert();
      this.returnMessage = "";
      this.surveyTakerId = "";
      this.surveyTakerList = [];
      this.error = false;
      this.inputType = "list";
      this.setDisplayView(true);
      this.setModalLoading(false);      
    },
    closeModal() {
      this.setDisplayView(false);
      AlertService.closeAlert();
      if (this.$refs[this.modalId] != null) {
        this.$refs[this.modalId].visible = false;
      }
      this.refreshModal = !this.refreshModal;
      this.$router.go(0);
    },
  },
  watch: {},
};
</script>
